import {LabelRegular, MultilineEllipsis, TextRegular} from '@hm/fundamental'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

// TODO: HCP-95631 Temporary type fix
const MultilineEllipsisWithChildren = MultilineEllipsis as React.FC<{
  lines: number | null
  onEllipsisShow?: () => void
  onEllipsisHidden?: () => void
  className?: string
  'data-cy'?: string
  children?: React.ReactNode
}>

export const CommentTextContent = ({content}: {content: string}) => {
  const [readMore, setReadMore] = useState(false)
  const [hasTrimmedContent, setHasTrimmedContent] = useState(false)
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <>
      <MultilineEllipsisWithChildren
        lines={readMore ? null : 2}
        onEllipsisShow={() => setHasTrimmedContent(true)}
        onEllipsisHidden={() => setHasTrimmedContent(false)}
      >
        <TextRegular>{content}</TextRegular>
      </MultilineEllipsisWithChildren>
      {hasTrimmedContent && !readMore && (
        <LabelRegular
          className="text-foreground_interaction hover:text-foreground_interaction_hover cursor-pointer"
          onClick={() => setReadMore(true)}
        >
          {t('comments.label.readMore')}
        </LabelRegular>
      )}
    </>
  )
}
